import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionStorageService } from 'ngx-webstorage';
import { Observable, ReplaySubject, of } from 'rxjs';
import { shareReplay, tap, catchError } from 'rxjs/operators';
import { ApplicationConfigService } from '../core/config/application-config.service';
import { Account } from './account.model';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private userIdentity: Account | null = null;
  private authenticationState = new ReplaySubject<Account | null>(1);
  private accountCache$?: Observable<Account> | null;
  private resourceUrl: string | any;

  constructor(private http: HttpClient, private applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('account-portal/user/me');
  }

  save(account: Account): Observable<{}> {
    return this.http.post(this.resourceUrl, account);
  }

  authenticate(identity: Account | null): void {
    this.authenticationState.next(identity);
    if (!identity) {
      this.accountCache$ = null;
    }
  }

  hasAnyAuthority(userIdentity: Account, authorities: string[] | string): boolean {
    if (!userIdentity) {
      return false;
    }
    if (!Array.isArray(authorities)) {
      authorities = [authorities];
    }

    // return userIdentity.roleList.some((authority: string) => authorities.includes(authority));
    // return authorities.includes(userIdentity.roleList[0].roleName);
    return true;
  }

  identity(force?: boolean): Observable<Account | null> {
    if (!this.accountCache$ || force) {
      this.accountCache$ =
        this.fetch().pipe(
          tap((res: any) => {
            this.authenticate(res.data);

            // After retrieve the account info, the language will be changed to
            // the user's preferred language configured in the account setting
            // unless user have choosed other language in the current session
            // if (!this.sessionStorageService.retrieve('locale')) {
            //   this.translateService.use(account.langKey);
            // }

            // this.navigateToStoredUrl();
          }),
          shareReplay(),
        ) ?? null;
    }
    return this.accountCache$.pipe(catchError(() => of(null)));
  }

  isAuthenticated(userIdentity: Account): boolean {
    return userIdentity !== null;
  }

  getAuthenticationState(): Observable<Account | null> {
    return this.authenticationState.asObservable();
  }

  fetch(): Observable<Account> {
    return this.http.get<Account>(this.resourceUrl);
  }

  resetPassword(resetPassword: any): Observable<any> {
    const resourceUrl = this.applicationConfigService.getEndpointFor('account-portal/user/users/reset/password');
    return this.http.post(resourceUrl, resetPassword);
  }

  checkResetKey(key: any): Observable<any> {
    const resourceUrl = this.applicationConfigService.getEndpointFor(`account-portal/user/check/reset-link/${key}`);
    return this.http.get(resourceUrl);
  }

  changePassword(changePassword: any): Observable<any> {
    const resourceUrl = this.applicationConfigService.getEndpointFor('account-portal/user/users/change/password');
    return this.http.post(resourceUrl, changePassword);
  }

  getEmoneymessage(username: any): Observable<any> {
    const resourceUrl = this.applicationConfigService.getEndpointFor(`account-portal/get/emoney/message/${username}`);
    return this.http.get(resourceUrl);
  }
}
